module.exports = __webpack_public_path__ + "static/media/location.1095fec4.svg";